import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AdminService } from 'src/app/Service/admin.service';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { GraphConfigReportNameComponent } from '../graph-config-report-name/graph-config-report-name.component';


@Component({
  selector: 'app-add-new-graph-config',
  templateUrl: './add-new-graph-config.component.html',
})
export class AddNewGraphConfigComponent implements OnInit {
  Formula: string = '';
  isForViewFormula: boolean = false;
  isDisplayFormula: boolean = false;
  ParameterList = [];
  GraphConfigform: FormGroup;
  EnergyMeterList = [];
  errorMsg: string = '';
  successMsg: string = '';
  meterId: any = '';
  EnergymeterName: any;
  RegisterData: any;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  CompanyId: number;
  GraphConfigList: any = [];
  GraphConfigId: number;
  GraphConfigData: any;
  isdatacount: boolean;
  editedName: any;
  FromTime: any;
  mainregisterlist: any;
  selecteddatatype: any;
  selectedregisterslist: any;
  showTooltip: boolean = false;
  registeraddtion: any;
  isShowTotal: any;
  reportconfigbutton: any;
  grandTotalTypeslist: any;
  isSelectionMade: boolean;
  selectedData: any = []
  selectedtotaltype: any;

  constructor(private dialog: MatDialog, private GSMConfigService: GSMConfigurationService, public adminService: AdminService, public dialogRef: MatDialogRef<AddNewGraphConfigComponent>, private commonservice: CommonService, private formBuilder: FormBuilder, private authService: AuthService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.GraphConfigform;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {


    this.GraphConfigform = this.formBuilder.group({
      MeterId: ['', [Validators.required]],
      RegisterDataId: ['', [Validators.required]],
      DataType: ['', [Validators.required]],
      RegisterName: [''],
      FromTime: [''],
      ToTime: [''],
      Interval: [''],
      GraphConfigName: ['', [Validators.required]],
      isShowTotal: ['']
    });
    this.getEnergyMeterData();
    this.Getdropdownlist()
    //Call service for validation on value change
    this.GraphConfigform.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.GraphConfigform, true)
    );

    this.GraphConfigData = this.data.GraphConfigData;
    this.CompanyId = +localStorage.getItem('CompanyIdForUC');
    this.GraphConfigId = this.data.data
    if (this.GraphConfigId == 0) {
      this.reportconfigbutton = true
    }
    else {
      this.reportconfigbutton = false
    }
    if (this.GraphConfigId > 0) {
      setTimeout(() => {
        this.adminService.GetGraphConfigDetailsbyId(this.GraphConfigId).subscribe(
          (result) => {
            this.FromTime = result.FromTime


            this.GraphConfigList = [];
            this.GraphConfigList = result.listGraphConfigDetails
            this.editedName = result.GraphConfigName
            this.GraphConfigform.controls['GraphConfigName'].patchValue(result.GraphConfigName);
            this.GraphConfigform.controls['isShowTotal'].patchValue(result.isShowTotal);
            this.selectedtotaltype = result.isShowTotal
            this.GraphConfigList.forEach((element: any, i: number) => {
              element.GraphConfigId = this.GraphConfigId
              var EnergyMeterName = this.EnergyMeterList.filter(e => e.CodeValue == element.EnergymeterMasterID)[0].CodeDisplayText;
              this.ParameterList.push({
                'MeterName': EnergyMeterName, 'RegisterName': element.RegisterName, 'RegisterDataId': element.RegisterId,
                'DataType': element.DataType, 'ColumnTotal': element.ColumnTotal,
                // 'IsForTotal': element.IsForTotal
              });


              this.ParameterList
                .filter(item => item.ColumnTotal == true)
                .forEach(item => {
                  if (!this.selectedData.some(selectedItem => selectedItem === item)) {
                    this.selectedData.push(item);
                  }
                });

            })

          },
          (error) => {
            this.errorMsg = error
          }
        )
      }, 100);
    }
  }

  // Get Energy Meter Data
  getEnergyMeterData() {
    this.commonservice.GetEnergyMeterIdList(0, 0, 'N').subscribe(
      (result) => {
        this.EnergyMeterList = result;
        const codeValues = this.EnergyMeterList.map(item => item.CodeValue);
        codeValues.forEach((codeValue) => {
          this.GSMConfigService.GetRegisterdata(codeValue, 'N', '', '').subscribe(
            (result) => {
              if (result.listRegisterdata != null) {
                this.RegisterData = this.RegisterData && this.RegisterData.length != 0 ? this.RegisterData.concat(result.listRegisterdata) : this.RegisterData = result.listRegisterdata;


              }
            },
            (error) => {
              this.errorMsg = error;
            }
          );
        });
      },
      (error) => {
        this.errorMsg = error
      }
    )
    setTimeout(() => {
      this.RegisterData.forEach(register => {
        // Find the matching EnergyMeter based on EnergymeterMasterID
        const matchingEnergyMeter = this.EnergyMeterList.find(meter => meter.CodeValue == register.EnergymeterMasterID);

        if (matchingEnergyMeter) {
          register.RegisterName = `${register.RegisterName} - ${matchingEnergyMeter.CodeDisplayText}`;
        }

      });


    }, 1000);

  }

  removeEmptyStrings(array: string[]): string[] {
    return array.filter(item => item != "");
  }

  // On change Energy Meter
  OnChangeEnergymeter(event) {
    event.value = this.removeEmptyStrings(event.value);
    this.mainregisterlist = []
    this.GraphConfigform.patchValue({
      MeterId: event.value
    });
    this.meterId = event.value;
    // var temp1 
    event.value.forEach(element => {
      // Filter RegisterData and push matching items to mainregisterlist

      this.RegisterData.filter(item => item.EnergymeterMasterID == element)
        .forEach(filteredItem => {
          this.mainregisterlist.push(filteredItem);
        });
    });

    this.EnergymeterName = event.source.triggerValue;

  }

  // On change Register Name
  OnChangeRegisterName(event) {

    // If any valid selection is made, mark the flag as true
    this.isSelectionMade = event.value && event.value.length > 0;

    // Remove empty strings or 'null' values if any are selected
    event.value = this.removeEmptyStrings(event.value);

    // Clear selected registers list
    this.selectedregisterslist = [];

    // Populate selected registers list based on the selected RegisterDataIds
    event.value.forEach(element => {
      this.mainregisterlist.filter(item => item.RegisterDataId == element)
        .forEach(filteredItem => {
          this.selectedregisterslist.push(filteredItem);
        });
    });
  }



  OnChangeDataType(eve: any) {
    this.selecteddatatype = eve
  }
  OnChangeTotalType(eve: any) {
    this.selectedtotaltype = eve
  }
  // Get Register Data
  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', '', '').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;


          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  DeleteGraphConfigData(i) {
    this.errorMsg = "";
    this.ParameterList.splice(i, 1);
    this.GraphConfigList.splice(i, 1);
  }
  checkFormValidity(): void {
    Object.keys(this.GraphConfigform.controls).forEach(key => {
      const control = this.GraphConfigform.get(key);
      if (control && control.invalid) {
        const errors = control.errors;
        if (errors) {
        }
      }
    });
  }
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  AddRegisters() {
    this.registeraddtion = ""
    this.errorMsg = '';
    this.successMsg = '';
    // this.GraphConfigform.value.RegisterName = RegisterName
    if (this.GraphConfigform.invalid) {
      this.checkFormValidity();
      this.GraphConfigform.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.GraphConfigform, true);
      return;
    }
    var existGraphConfigName = this.GraphConfigData.filter(p => p.GraphConfigName.toLowerCase() == this.GraphConfigform.value.GraphConfigName.toLowerCase());
    var editedName = this.GraphConfigform.value.GraphConfigName ? this.GraphConfigform.value.GraphConfigName.toLowerCase() : ''
    const otherNames = this.GraphConfigData.filter(name => name.GraphConfigName.toLowerCase() !== this.editedName);
    const nameExists = otherNames.filter(p => p.GraphConfigName ? p.GraphConfigName.toLowerCase() : '' == editedName);

    if (this.GraphConfigId == 0 && existGraphConfigName && existGraphConfigName.length > 0) {
      this.errorMsg = 'Custom Report configuration name already exist!!';
      return;
    }

    let duplicates = [];

    this.selectedregisterslist.forEach(element => {

      const exists = this.GraphConfigList.some(item =>
        item.EnergymeterMasterID == element.EnergymeterMasterID &&
        item.RegisterId == element.RegisterDataId &&
        item.DataType == this.selecteddatatype
      );
      if (exists) {
        let registername = element.RegisterName.split('-')[0].trim();
        let meterid = element.EnergymeterMasterID;
        let metername: any = this.EnergyMeterList.filter(item => item.CodeValue == meterid);

        duplicates.push(` ${metername[0].CodeDisplayText} - ${registername} - ${this.selecteddatatype}`);
      } else {

        let newobj = {
          GraphConfigDetailId: 0,
          GraphConfigId: this.GraphConfigId ? this.GraphConfigId : 0,
          EnergymeterMasterID: element.EnergymeterMasterID,
          RegisterId: element.RegisterDataId,
          DataType: this.selecteddatatype,
          ColumnTotal: false
        };
        this.GraphConfigList.push(newobj);
        var meterid = element.EnergymeterMasterID
        var metername: any = this.EnergyMeterList.filter(item => item.CodeValue == meterid)

        let newobj1 = {
          MeterName: metername[0].CodeDisplayText,
          RegisterName: element.RegisterName.split('-')[0].trim(),
          RegisterDataId: element.RegisterDataId,
          DataType: this.selecteddatatype,
          ColumnTotal: false
        }
        this.ParameterList.push(newobj1)
      }
    });
    // If there are duplicates, set the error message
    if (duplicates.length > 0) {
      this.registeraddtion = duplicates.join("\n");
    }
  }
  //Save Parameter Config Data
  SaveParameterConfigData() {
    this.registeraddtion = ""
    this.errorMsg = '';
    this.successMsg = '';

    if (this.ParameterList.length == 0) {
      this.errorMsg = 'Add Atleast 1 Register'
      return;
    }



    // Set all ColumnTotal to false initially
    this.GraphConfigList.forEach(graphConfig => {
      graphConfig.ColumnTotal = false;
    });

    // Iterate over selectedData and update GraphConfigList
    this.selectedData.forEach(selected => {
      this.GraphConfigList.forEach(graphConfig => {
        // Check if RegisterId and DataType match
        if (
          graphConfig.RegisterId == selected.RegisterDataId &&
          graphConfig.DataType == selected.DataType
        ) {
          // Set ColumnTotal to true for matching data
          graphConfig.ColumnTotal = true;
        }
      });
    });

    var param = { ...this.GraphConfigform.value }
    let allcurrentflag = this.GraphConfigList.every(item => item.DataType == "Current");
    var reqObj = {
      GraphConfigId: this.GraphConfigId ? this.GraphConfigId : 0,
      GraphConfigName: param.GraphConfigName,
      CompanyId: this.CompanyId,
      isShowTotal: param.isShowTotal,
      allCurrentFlag: allcurrentflag,
      listGraphConfigDetails: this.GraphConfigList
    };
    this.adminService.TransGraphConfigDetails(reqObj).subscribe(
      (result) => {
        if (result = 'Success' && this.GraphConfigId == 0) {
          this.successMsg = 'Custom Report Configuration Details Added Successfully!!';
        }
        else {
          this.successMsg = 'Custom Report Configuration Details Updated Successfully!!';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  onCheckboxChange(element: any, isChecked: boolean) {

    if (!this.selectedData.includes(element) && isChecked) {
      this.selectedData.push(element);
    }
    else if (this.selectedData.includes(element) && !isChecked) {
      const indexToRemove = this.selectedData.indexOf(element);
      if (indexToRemove !== -1) {
        this.selectedData.splice(indexToRemove, 1);
      }
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.errorMsg = ''
    this.successMsg = ''
  }

  OpenReportSettings() {
    const reportconfig = this.dialog.open(GraphConfigReportNameComponent, {
      width: '1200px',
      height: 'auto',
      data: {
        GraphConfigId: this.data.data,
      },
      disableClose: true
    });
  }
  Getdropdownlist() {
    let reqpara = 'GrandTotalTypes';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(
      (result) => {
        this.grandTotalTypeslist = result['listGrandTotalTypes'];
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
}
